import React from 'react';

import Routes from './routes';
import './index.scss';
import 'semantic-ui-css/semantic.min.css';

const App = () => <Routes />;

export default App;
